// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"TsK1z3","input":"ihFyrM"};